<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-row>
            <b-col v-for="transaction in transactionData" :key="transaction.mode" md="12" lg="4">
                <b-card class="card-transaction" no-body>
                    <b-card-body>
                        <div class="transaction-item">
                            <b-media no-body>
                                <b-media-aside>
                                    <b-avatar rounded size="42" :variant="transaction.avatarVariant">
                                        <feather-icon size="18" :icon="transaction.avatar" />
                                    </b-avatar>
                                </b-media-aside>
                                <b-media-body>
                                    <h5 class="transaction-title mb-0" :class="transaction.color">
                                        {{ transaction.mode }}
                                    </h5>
                                    <small>{{ transaction.types }}</small>
                                </b-media-body>
                            </b-media>
                            <h4 class="mb-0" :class="transaction.color">
                                {{ transaction.payment.toLocaleString('fa-IR') }}
                            </h4>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-card>
            <b-row>
                <b-col md="4" lg="2" class="mt-25">
                    <b-form-group label="مجموعه" label-for="storeId">
                        <v-select v-model="parameters.storeId" dir="rtl" :options="listStores" id="storeId"
                            autocomplete="off" :reduce="(value) => value.id"
                            :get-option-label="(option) => option.name_Fa ? option.name_En + ' - ' + option.name_Fa : option.name_En"
                            :clearable="false">
                            <template #option="{ name_En, name_Fa }">
                                {{ name_En }} <span v-if="name_Fa">- {{ name_Fa }}</span>
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="4" lg="2" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col md="4" lg="2" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            autocomplete="off" :value="parameters.from ? formatDate(parameters.to) : null" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col md="4" lg="2" class="mt-25">
                    <b-form-group label="نوع سفارش" label-for="typeId">
                        <v-select v-model="parameters.type" dir="rtl" :options="typeData" id="typeId" autocomplete="off"
                            :reduce="(value) => value.id" style="border-radius: 8px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="4" lg="2" class="mt-25">
                    <b-form-group label="نوع پرداخت" label-for="paymentMethodId">
                        <v-select v-model="parameters.paymentMethod" dir="rtl" :options="paymentMethodData"
                            autocomplete="off" id="paymentMethodId" :reduce="(value) => value.id"
                            style="border-radius: 8px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="4" lg="2" class="mt-md-2 mt-1">
                    <b-button @click="reportOrders" variant="primary" class="w-100 mt-md-25 mt-0">اعمال
                        فیلتر</b-button>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        vSelect
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            loadingButton: false,
            history: [],
            paymentMethodData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'نقدی' },
                { id: 1, name: 'کارت' },
                { id: 2, name: 'درگاه' },
                { id: 3, name: 'واریز به حساب' },
                { id: 255, name: 'ترکیبی' },
            ],
            typeData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'داخل سالن' },
                { id: 1, name: 'بیرون بر' },
            ],
            transactionData: [
                {
                    mode: 'جمع مبلغ فروش',
                    types: 'ریال',
                    avatar: 'ArrowUpCircleIcon',
                    avatarVariant: 'light-primary',
                    payment: null,
                    color: 'text-primary',
                },
                {
                    mode: 'جمع مبلغ مرجوعی',
                    types: 'ریال',
                    avatar: 'ArrowDownCircleIcon',
                    avatarVariant: 'light-danger',
                    payment: null,
                    color: 'text-danger',
                },
                {
                    mode: 'مبلغ خالص فروش',
                    types: 'ریال',
                    avatar: 'DollarSignIcon',
                    avatarVariant: 'light-success',
                    payment: null,
                    color: 'text-success',
                },
            ],
            fields: [
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'totalAmount',
                    label: 'مبلغ فاکتور (ریال)',
                },
                {
                    key: 'discountAmount',
                    label: 'تخفیف (ریال)',
                },
                {
                    key: 'taxAmount',
                    label: 'مالیات (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'paymentMethod',
                    label: 'نوع پرداخت',
                },
                {
                    key: 'isReturned',
                    label: 'وضعیت مرجوعی',
                },
                {
                    key: 'registeredBy',
                    label: 'ثبت کننده',
                },
            ],
            currentDate: '',
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                from: null,
                to: null,
                storeId: null,
                paymentMethod: null,
                type: null,
            },
            orderId: null,
            usersList: [],
            parametersStores: {
                pageIndex: 1,
                pageSize: 90,
            },
            listStores: []
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        reportOrders() {
            this.loading = true
            adminService.reportOrders(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.history = data.items
                this.transactionData[0].payment = data.totalSell + data.totalReturned
                this.transactionData[1].payment = data.totalReturned
                this.transactionData[2].payment = data.totalSell
                this.loadingPage = false
                this.loading = false
            })
        },
        getListStores() {
            adminService.getListStores(this.parametersStores).then(({ data }) => {
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.name_En) {
                            this.listStores.push(obj)
                        }
                    });
                }
                this.listStores.unshift({
                    id: null,
                    name_En: 'نمایش همه'
                })
                this.reportOrders()
            })
        },
    },
    mounted() {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.parameters.from = this.formatDate2(today);
        this.parameters.to = this.formatDate2(tomorrow);
        this.currentDate = this.parameters.to;
        this.getListStores()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>